import { useContext } from 'react';
import FormButton from './FormButton';
import { AppContext } from '../../../contextApi/ContextApi';

export default function FormAddImage({website, action=null, directory, dynamicPath, isArray=false, arrayIndex=null, arrayField="imgURL", toUpdateDoc=true, label, text, type, _required, _id, uniqueAction=null, uniqueData=null, inputResetAction}) {
    const { fileRef, isCatchImage, isUploading, handleChangeImage, handleUploadImage } = useContext(AppContext);
    const upload =async()=>{
        await handleUploadImage(_required, website, directory, dynamicPath, isArray, arrayIndex, arrayField, toUpdateDoc, action, uniqueAction, uniqueData, inputResetAction)
    }
    
    return (
        <div className='dashboardForm_addImage'>
            <label htmlFor={_id} className='imageUploader_label' style={{backgroundColor:`${website?.settings?.theme?.primary_color}`, color:`${website?.settings?.theme?.accent_color}`}}>{isCatchImage ? "טוען.." : label}</label>
            <input id={_id} disabled={isCatchImage} style={{display:"none"}} type="file" accept='image/*' onChange={handleChangeImage}/>
            {fileRef && <p style={{margin:"0"}}>selected file: {fileRef?.name}</p>}
            <FormButton type={type} disabled={isUploading} website={website} text={text} action={upload}/>
        </div>
    )
}
